import React, { useEffect, useRef } from 'react';
import './Gallery.css';

const galleryData = [
  {
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&q=80',
    step: '01',
    title: '和面',
    description: '精选河套面粉，配以碱性矿泉水和面'
  },
  {
    image: 'https://images.unsplash.com/photo-1506368249639-73a05d6f6488?w=600&q=80',
    step: '02',
    title: '醒面',
    description: '恒温醒发2小时，面筋充分舒展'
  },
  {
    image: 'https://images.unsplash.com/photo-1585032226651-759b368d7246?w=600&q=80',
    step: '03',
    title: '拉面',
    description: '24次拉伸，8秒成型，面如银丝'
  },
  {
    image: 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=800&q=80',
    step: '04',
    title: '熬汤',
    description: '大骨、老母鸡、文火熬制12小时'
  },
  {
    image: 'https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=600&q=80',
    step: '05',
    title: '煮面',
    description: '沸水入锅，89秒精准捞出'
  },
  {
    image: 'https://images.unsplash.com/photo-1552611052-33e04de081de?w=600&q=80',
    step: '06',
    title: '出餐',
    description: '一勺浓汤、一把葱花、一碗好面'
  }
];

const Gallery = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    if (sectionRef.current) {
      const items = sectionRef.current.querySelectorAll('.gallery-item');
      items.forEach((item) => {
        item.style.opacity = '0';
        item.style.transform = 'translateY(30px)';
        observer.observe(item);
      });
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="gallery" className="gallery" ref={sectionRef}>
      <div className="section-header light">
        <span className="section-label">匠心工艺</span>
        <h2 className="section-title">面的诞生</h2>
      </div>
      <div className="gallery-grid">
        {galleryData.map((item, index) => (
          <div
            key={index}
            className="gallery-item"
            style={{ backgroundImage: `url('${item.image}')` }}
          >
            <div className="gallery-content">
              <div className="step-number">{item.step}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Gallery;
